import CloseIcon from '@mui/icons-material/Close';
import { Alert, Snackbar } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'react-i18next';

import AlertMessageModel from '../../../models/AlertMessage';

import './AlertMessage.scss';

interface IAlertMessage {
  alertBody: AlertMessageModel;
  setOpen: (open: boolean) => any;
}

const AlertMessage = ({ alertBody, setOpen }: IAlertMessage): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className="box_message__main">
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={6000}
        open={alertBody.open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <Alert severity={alertBody.severity} sx={{ width: '100%' }}>
          {alertBody.translate
            ? t(`messages.${alertBody.message}`)
            : alertBody.message}
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Alert>
      </Snackbar>
    </div>
  );
};

export default AlertMessage;
